var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "zti5a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zti5b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 9.25v1.5H5v-1.5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zti5c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 9.25v1.5H5v-1.5z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#8bc640",
    strokeMiterlimit: 50,
    strokeWidth: 2,
    d: "M0 10C0 4.477 4.477 0 10 0h0c5.523 0 10 4.477 10 10v0c0 5.523-4.477 10-10 10h0C4.477 20 0 15.523 0 10z",
    clipPath: "url(\"#zti5a\")"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#d8d8d8",
    d: "M15 9.25v1.5H5v-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#979797",
    strokeMiterlimit: 50,
    strokeWidth: 2,
    d: "M15 9.25v1.5H5v0-1.5 0z",
    clipPath: "url(\"#zti5b\")"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zti5c)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#8bc640",
    d: "M-2-2h24v24H-2z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.f0a38392f292015c3a3a570945603c87.svg";
export { ForwardRef as ReactComponent };